module.exports = __webpack_public_path__ + "img/home-card.c64a5121.png";